module.exports = __webpack_public_path__ + "img/water-treatment-plant-text.17cfb9b3.svg";